<div class="row">
  <div class="col-12">
    <p class="mbottom-12">
      <transloco
        id="2e7f6e58-9771-42df-818a-8572c7f1e160"
        key="accountUi.reactivateAccountUi.confirmToReactivate"
        [params]="{ days: days$ | async }"></transloco>
    </p>
  </div>
</div>
<yat-buttons
  [primaryButtonName]="'accountUi.reactivateAccountUi.reactivateAccount' | transloco"
  [secondaryButtonName]="('cancel' | commonWording | async) ?? ''"
  (primaryButtonClickMethod)="reactivate()"
  (secondaryButtonClickMethod)="cancel()">
</yat-buttons>
<div class="row mtop-12">
  <div class="col-12">
    <p class="color-light c-gray font-small text-center mb-0 mbottom-16" yat-link>
      <transloco
        id="42132eae-28a0-424b-989d-20d9ca7dc4f8"
        key="accountUi.reactivateAccountUi.agreeToTermsAndPrivacyPolicy"
        [params]="TERMS_AND_PRIVACY_POLICY"></transloco>
    </p>
  </div>
</div>
